import {useEffect, useRef} from 'react';
import {Loading} from './components';
import {WhatsAppSettings} from './whatsapp-settings';
import {useHermes} from './lib/store';
import type {HermesState} from './lib/types';
import './whatsapp-dialog.css';

export function WhatsAppDialog({state, actions, sessionId, onClose}: {
  state: HermesState; actions: ReturnType<typeof useHermes>['actions']; sessionId: string | undefined; onClose: () => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  useEffect(() => {dialog.current?.showModal();}, []);
  return <dialog ref={dialog} className="whatsapp-dialog" aria-label="WhatsApp pairing" onClose={onClose}
    onClick={event => {
      if (event.target !== event.currentTarget) return;
      const bounds = event.currentTarget.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
        event.currentTarget.close();
      }
    }}>
    <button type="button" className="text-button whatsapp-dialog-close" autoFocus onClick={() => dialog.current?.close()}>Close</button>
    {!sessionId ? <Loading/>
      : <WhatsAppSettings state={state} actions={actions} surface="workspace" sessionId={sessionId}/>}
  </dialog>;
}
